<template>
  <div class="created-warp">
    <div class="content tab-content">
      <div class="right">
        <div class="search">
          <el-select v-model="search.dateTimeType" size="small" class="w-150" placeholder="请选择时间类型">
            <el-option :value="1" :label="'合同签订时间'"></el-option>
            <el-option :value="2" :label="'合同时间'"></el-option>
          </el-select>
          <el-date-picker v-model="search.startTime" class="w-150" size="small" type="datetime" placeholder="选择日期时间">
          </el-date-picker>
          -
          <el-date-picker v-model="search.endTime" class="w-150" size="small" type="datetime" placeholder="选择日期时间">
          </el-date-picker>

          <el-button class="m-l-10" size="small" @click="getData" type="primary">查询</el-button>
        </div>
        <div class="table-content">
          <nk-table :data="tableData" :columns="columns" :showPage="false">
            <el-table-column slot="status" label="合同状态" width="100" align="center">
              <template slot-scope="scope">
                {{status[scope.row.status]}}
              </template>
            </el-table-column>
            <el-table-column slot="operation" label="操作" width="100" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="lookRow(scope.row,scope.$index)">查看详情</el-button>
              </template>
            </el-table-column>
          </nk-table>
        </div>
      </div>
    </div>

    <lt-msg-box :visible="dialogVisible" :showFoot="false" @cancel="dialogVisible = false" title="合同详情">
      <div class="from-content">
        <contract :contract="selectedRow" v-if="dialogVisible"></contract>
      </div>
    </lt-msg-box>
  </div>
</template>

<script>
import NkTable from "@/components/common/NkTable";
import api from "@common/api/index.js";
import utils from '@common/utils/index.js'
import dateTool from "@/utils/dateTool.js"
import LtMsgBox from '@/components/common/LtMsgBox.vue'
import Contract from './Contract.vue'
import config from '@common/config/index.js'
export default {
  components: { NkTable, LtMsgBox, Contract },
  data () {
    return {
      status: config.contractState,
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      selectedCompany: null,
      search: {
        signingTimeLeft: null,
        signingTimeRight: null,
        startTime: null,
        endTime: null,
        dateTimeType: 1
      },
      columns: [
        {
          prop: "signingTime",
          label: "签订时间",
          show: true,
        },
        {
          prop: "startTime",
          label: "合同开始时间",
          show: true,
        },
        {
          prop: "endTime",
          label: "合同结束时间",
          show: true,
        },
        {
          prop: "propertyCompanyName",
          label: "物业公司",
          show: true,
        },
        {
          prop: "propertyTransactorNickname",
          label: "处理人",
          show: true,
        },
        {
          prop: "status",
          slot: "status",
          label: "合同状态",
          show: true,
        },
        { prop: "operation", slot: "operation", label: "操作", show: true },
      ],
      tableData: [],
      dialogVisible: false,
      selectedRow: null
    }
  },
  created () {
    this.getData()
  },
  methods: {
    getData () {
      let { dateTimeType, startTime, endTime } = this.search
      let signingTimeLeft = null
      let signingTimeRight = null
      if (dateTimeType === 1) {
        signingTimeLeft = this.cheackNull(startTime)
        signingTimeRight = this.cheackNull(endTime)
        startTime = null
        endTime = null
      }
      else {
        startTime = this.cheackNull(startTime)
        endTime = this.cheackNull(endTime)
      }
      api.rentalArea.getLeaseContractForCompanyLessee(0, null, signingTimeLeft, signingTimeRight, startTime, endTime, -1).then(res => {
        if (res.data) {
          this.tableData = res.data
        } else {
          this.tableData = []
        }
      })
    },
    cheackNull (time) {
      if (time) {
        return dateTool.format(time, 'yyyy/MM/dd hh:mm:ss')
      }
      return null
    },
    lookRow (row, index) {
      this.selectedRow = row
      this.dialogVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.created-warp {
  width: 100%;
  height: 100%;
  padding: 14px;
  box-sizing: border-box;
  text-align: left;
  color: #000;
  .content {
    width: 100%;
    height: 100%;
    padding: 14px;
    box-sizing: border-box;
    background: #fff;
    display: flex;

    .left {
      flex: 0 0 200px;
      overflow: auto;
      .left-title {
        height: 32px;
        line-height: 32px;
        background: #409eff;
        color: #fff;
        padding: 0px 10px;
      }
      .left-content {
        height: calc(100% - 32px);
        padding: 0px 10px;
      }
    }
    .right {
      flex: 1;
      display: flex;
      flex-flow: column;
      padding-left: 10px;
      overflow: auto;
      .search {
        flex: 0 0 42px;
      }
      .table-content {
        flex: 1;
        overflow: auto;
      }
      .w-150 {
        width: 150px;
      }
      .m-l-10 {
        margin-left: 10px;
      }
    }
  }
  .from-content {
    width: 600px;
    padding: 0px 10px;
  }
}
</style>